export enum Hashes {
  TAB = 'tab',
  ITEM_VALUE = 'item-value',
  ORDER_VALUE = 'order-value',
  EMAIL_VALUE = 'email-value',
  LOGIN_ID_VALUE = 'login-id-value',
  PHONE_NUMBER_VALUE = 'phone-number-value',
  TAB_VALUE_REFETCH = 'tab-value-refetch',
  ITEM_TAB = 'item-tab',
  CLIENT_TAB = 'client-tab',
  CURRENT_ORDER_ITEM = 'current-order-item',
  CURRENT_EMAIL_ITEM = 'current-email-item',
  CURRENT_CLIENT_ID_ITEM = 'current-client-id-item',
  CURRENT_CLIENT_PHONE_NUMBER_ITEM = 'current-client-phone-number-item',
  SECTION = 'section',
}

export enum Tab {
  ITEM = 'item',
  ORDER = 'order',
  EMAIL = 'email',
  LOGIN_ID = 'login-id',
  PHONE_NUMBER = 'phone-number',
}
